<template>
  <div id="home">
    <el-container id="home" >
        <el-aside width="auto">
            <div class="logo" :class="{collapse:isCollapse}">
                <!-- <div class="logoImg">
                    <img :src="'./static/images/'+logo">
                </div> -->
                <span class="sysName">{{sysName}}</span>
            </div>
            <div class="menu">
                <el-scrollbar wrap-class="scrollbar-wrapper">
                    <el-menu ref='menu' :default-active="menuIndex" class="el-menu-vertical-demo" :collapse="isCollapse"  @select="handleSelect" >
                        <menulist :list="menu"></menulist>
                    </el-menu>
                </el-scrollbar>
            </div>
        </el-aside>
        <el-container>
            <el-header height='80px'>
                <div class="left-btn">
                    <i :class="isCollapse? 'el-icon-s-unfold':'el-icon-s-fold' " @click="collapseMenu"> </i>
                </div>
                <div class="right">
                     <el-avatar icon="el-icon-user-solid" :src="user.avatar"></el-avatar>
                     <div class="userInfo-menu">
                        <el-dropdown @command="handleCommand">
                            <span class="el-dropdown-link">
                                {{user.nick}}<i class="el-icon-arrow-down el-icon--right"></i>
                            </span>
                            <el-dropdown-menu slot="dropdown">
                                <el-dropdown-item command="updPwd">修改密码</el-dropdown-item>
                                <el-dropdown-item command="logOut">退出登录</el-dropdown-item>
                            </el-dropdown-menu>
                        </el-dropdown>
                    
                     </div>
                </div>
            </el-header>
            <el-main>
                <transition name="el-fade-in">
                    <router-view></router-view>
                </transition>
            </el-main>
        </el-container>
    </el-container>
    <el-dialog title="修改密码"  :visible.sync="editPassWordVisible" :close-on-press-escape="false" :show-close="this.user.flag!==1" :close-on-click-modal="false" @close="$refs['editFrom'].resetFields();" width='300px'>
        <el-form  :model="editFrom" :rules="editRules"  ref="editFrom">
            <el-form-item label="" prop="oldPasswd">
                <el-input v-model="editFrom.oldPasswd" type="password" placeholder="原密码"></el-input>
            </el-form-item>
            <el-form-item label="" prop="newPasswd">
                <el-input v-model="editFrom.newPasswd" type="password" placeholder="新密码"></el-input>
            </el-form-item>
            <el-form-item label="" prop="confirmPasswd">
                <el-input v-model="editFrom.confirmPasswd" type="password" placeholder="确认新密码"></el-input>
            </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
            <el-button @click="editPassWordVisible = false" >取 消</el-button>
            <el-button type="primary" @click="updPwdSubmit">确 定</el-button>
        </div>
    </el-dialog>
  </div>
</template>

<script>
import { menu } from '../config/config';
import {encrypt} from '@/utils/rsaEncrypt'
import { mapState } from 'vuex'
import { logout, modifyAccount } from '@/apis/oms/common'
import { logout as be_logout, modifyAccount as be_modifyAccount} from '@/apis/backend/common'
export default {
  name: 'home',
  components: {
    menulist: resolve => { require(['../components/menu.vue'], resolve) },
  },

  data() {
    var chkConfirmPasswd = (rule, value, callback) => {
      if (this.editFrom.newPasswd !== this.editFrom.confirmPasswd) {
        callback(new Error('确认新密码错误'));
      } else {
        callback();
      }
    }

    return {
      logo: process.env.VUE_APP_LOGO,
      msg: 'home',
      menu: [],
      menuIndex: "",
      menuName: "",
      isCollapse: false,
      editFrom: {
        oldPasswd: "",
        newPasswd: "",
        confirmPasswd: "",
      },
      editRules: {
        oldPasswd: [{ required: true, message: "请输入原密码", trigger: "blur" }],
        newPasswd: [{ required: true, message: "请输入新密码", trigger: "blur" }],
        confirmPasswd: [
          { required: true, message: "请输入确认新密码", trigger: "blur" },
          { validator: chkConfirmPasswd, trigger: 'blur' }
        ]
      },
      editPassWordVisible: false,
    }
  },
  computed: {
    ...mapState({
      sysName: state => state.common.setting.sysName,
      dataDict: state => state.common.dataDict,
      user:state => state.userInfo.user
    })
    
  },
  watch: {
  '$route'(to, from) {
      let path = to.path;
      let menuItem = this.getMenu(path);
      if (menuItem != null && menuItem.id != this.menuIndex) {
        this.menuIndex = menuItem.id;
        this.setCurMenu(menuItem);
      }
    }
  },
  created() {
    console.log(this.sysName)
     this.menu = process.env.VUE_APP_TYPE == 'oms' ? menu.OMSMenu : menu.backendMenu;
    // if (this.user.roles == '0') {
    //   this.menu = menu.OMSMenu;
    // } else {
    //   this.menu = menu.schoolMenu;
    // }

    var path = this.$route.path;
    if (path.substring(path.length - 1) == "/") {
      path = path.substring(0, path.length - 1);

    }
    let menuItem = this.getMenu(path);
    if (menuItem != null) {
      this.menuIndex = menuItem.id;
      this.setCurMenu(menuItem);
    } else {
      menuItem = this.getFirstMenu();
      this.menuIndex = menuItem.id;
      this.setCurMenu(menuItem);
      this.$router.push({ path: menuItem.path });
    }


  },
  methods: {
    handleSelect(key, keyPath) {
      let curMenu = this.menu;
      for (let id of keyPath) {
        //如果是选中的结点
        if (id === key) {
          for (let item of curMenu) {
            if (item.id === id) {
              this.setCurMenu(item);
              this.$router.push({ path: item.path });
            }
          }
        } else {
          for (let item of curMenu) {
            if (item.id === id) {
              curMenu = item.children;
              break;
            }
          }
        }
      }
    },
    collapseMenu() {
      this.isCollapse = this.isCollapse ? false : true;
    },
    handleCommand(command) {
      if (command === "logOut") {
        this.logOut();
      } else if (command === "updPwd") {
        this.updPwd();
      }

    },
    logOut() {
      var loginUrl = '/login';
      //var loginUrl = '/login/' + this.$$dataDict.loginType[this.identity];
      this.$confirm('是否退出系统?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        let logoutAPI = process.env.VUE_APP_TYPE == 'oms' ? logout : be_logout;
        logoutAPI().then(data => { 
          this.$store.dispatch('remove_userinfo').then(() => {
            location.reload()
          });
        })
        // logout({
        //   isLoadingShow: true,
        //   fn: data => {
        //     this.$store.dispatch('remove_userinfo').then(() => {
        //       this.$router.push({ path: loginUrl });
        //     });
        //   }
        // })

      }).catch(() => {
      });
    },
    updPwd() {
      this.editFrom = {
        oldPasswd: "",
        newPasswd: "",
        confirmPasswd: "",
      };
      this.editPassWordVisible = true;
    },
    updPwdSubmit() {
      this.$refs['editFrom'].validate((valid) => {
        if (valid) {
          this.$confirm('是否确认修改密码?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            let modifyAccountAPI = process.env.VUE_APP_TYPE == 'oms' ? modifyAccount : be_modifyAccount;
            modifyAccountAPI({
              oldPasswd: encrypt(this.editFrom.oldPasswd),
              newPasswd:encrypt(this.editFrom.newPasswd),
            }).then(data => { 
              this.$message.success('密码修改成功！')
              this.editPassWordVisible = false;
            })
          }).catch(() => {
          });
        }
      });
    },
    getMenu(path, subMenu) {
      let menuItem = null;
      if (!subMenu) {
        subMenu = this.menu;
      }
      for (let item of subMenu) {
        if (item.children && item.children.length > 0) {
          let childrenMenu = this.getMenu(path, item.children)
          if (childrenMenu != null) {
            menuItem = childrenMenu;
            break;
          }

        } else {
          if (path === item.path) {
            menuItem = item;
            break;
          }
        }
      }
      return menuItem
    },
    getFirstMenu(subMenu) {
      let menuItem = null;
      if (!subMenu) {
        subMenu = this.menu;
      }
      if (subMenu[0].children && subMenu[0].children.length > 0) {
        let childrenMenu = this.getFirstMenu(subMenu[0].children)
        if (childrenMenu != null) {
          menuItem = childrenMenu;
        }
      } else {
        menuItem = subMenu[0]
      }
      return menuItem;
    },
    setCurMenu(menu) {
      this.$store.dispatch('update_selectedMenu', menu).then(() => {
        //console.log('设置当前菜单', menu)
      })
    }

  }
}
</script>

<style lang="scss" >
@import '../theme-variables.scss';
#home{
    width: 100%;
    height: 100%;
    .el-aside{
        display: flex;
        flex-direction: column;
        background-color: #545c64;
        .logo{
            display: flex;
            align-items: center;
            color:#fff;
            padding: 20px 0;
            text-align: center;
            box-sizing: border-box;
            max-width:200px;
            justify-content:center;
            img{
                width: 36px;
                max-width: 27px;
            }
            .logoImg{
                margin: 0 10px;
                background: #fff;
                width:40px;
                height:40px;
                border-radius: 50%;
                display: flex;
                justify-content: center;
                align-items: center;
                flex: 0 0 auto;
            }
            .sysName{
                padding-right: 10px;
            }
        }
        .collapse{
            // img{
            //     width:50px
            // }
            .sysName{
                display: none;
            }

        }
        .menu{
            flex:1;
            overflow: auto;
            .el-scrollbar{
                height: 100%;
                .scrollbar-wrapper {
                    overflow-x: hidden !important;
                }
                
                .el-scrollbar__thumb{
                    background-color: rgba(255,255,255,0.5);
                }
            
                .el-scrollbar__thumb:hover {
                    background-color: rgba(255,255,255,0.7);
                }
            }
            .el-menu-vertical-demo:not(.el-menu--collapse){
                width: 200px;
            }
            .el-menu{
                background: inherit;
                border:none;
                i,svg{
                    color:$--color-white;
                    fill:$--color-white;
                }
                span{
                    color:$--color-white;
                }
                
                .el-menu-item:hover{
                    background-color:rgb(67,74,80);
                    box-shadow:5px 5px 30px rgba(0,0,0,0.16);
                }
                .el-menu-item:focus{
                    background-color: inherit;
                }
                .svg-icon{
                  width: 24px;
                  text-align: center;
                  font-size: 14px;
                  vertical-align: middle;
                  margin: 0 auto;
                }
                .el-submenu__title:hover{
                    background-color:rgb(67,74,80);
                    box-shadow:5px 5px 30px rgba(0,0,0,0.16);
                }
                .el-menu-item.is-active{
                    background-color:rgb(67,74,80);;
                    box-shadow:5px 5px 30px rgba(0,0,0,0.16);
                }

            }
            .el-menu--collapse{
                //width:100px;
                .el-menu-item {
                    //height: 100px;
                    box-sizing: border-box;
                    .el-tooltip{
                        display: flex !important;
                        justify-content: center;
                        align-items: center;
                        i{
                            font-size: 20px;
                        }
                    }
                }
                .el-submenu{
                    .el-submenu__title{
                        //height: 100px;
                        display: flex;
                        justify-content: center;
                        align-items: center;
                        i{
                            font-size: 20px;
                        }
                    }
                }
            }
        }
    }
    .el-header{
        display: flex;
        justify-content: space-between;
        align-items: center;
        background: $--color-white;
        box-shadow:3px 0px 9px rgba(172,200,219,0.46);
        .left-btn{
            i{
                font-size: 30px;
                color:#A8ACB9;
            }
        }
        .right{
            
            display: flex;
            align-items: center;
            .el-dropdown{
                color:$--color-text-secondary;
            }
            .el-avatar{
                width:30px;
                height: 30px;
                line-height: 30px;
            }
            .userInfo-menu{
                margin-left: 10px;
                .el-dropdown{
                    cursor: pointer;
                }
            }
        }

    }
    
}
</style>